import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getProjects(data) {
    const url = `/${platform}/project/${data.id}/index`
    return request.get(url)
}

export function getProjectReports(data) {
    const url = `/${platform}/project/${data.advertiser_id}/reports`
    delete data.advertiser_id
    return request.post(url, data)
}

export function updateProjectByField(data) {
    const url = `/${platform}/project/${data.advertiser_id}/update`
    delete data.advertiser_id
    return request.patch(url, data)
}

export function storeProject(data) {
    const url = `/${platform}/project`
    return request.post(url, data)
}

export function deleteProject(data) {
    const url = `/${platform}/project/${data.advertiser_id}/destroy`
    return request.post(url, data)
}

export function updateProjects(data) {
    const url = `/${platform}/project/update_project`
    return request.post(url, data)
}

export function batchUpdateProjects(data) {
    const url = `/${platform}/project/batch_update_projects`
    return request.post(url, data)
}